// extracted by mini-css-extract-plugin
export default {"navLinks":"HeaderNavLinks_navLinks__qJJn8"};